import { render, staticRenderFns } from "./ItemListBrain.vue?vue&type=template&id=434145ac"
import script from "./ItemListBrain.vue?vue&type=script&lang=js"
export * from "./ItemListBrain.vue?vue&type=script&lang=js"
import style0 from "./ItemListBrain.vue?vue&type=style&index=0&id=434145ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports